module.exports = __webpack_public_path__ + "static/media/webdesign-services-img52.e73ac183.jpg";